var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageQuestion = function SvgMessageQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M6.125 5.251a1.312 1.312 0 0 1 2.549.437C8.674 6.563 7.362 7 7.362 7m.017 1.75h.006m-.094 2.917a4.958 4.958 0 1 0-4.7-3.374c.064.187.095.28.101.353a.5.5 0 0 1-.016.19c-.018.07-.057.142-.136.288l-.954 1.766c-.136.252-.204.378-.189.475.013.085.063.16.136.204.084.051.227.036.512.007l2.987-.309c.09-.01.136-.014.177-.012.04.001.069.005.109.014s.09.029.191.068c.553.213 1.154.33 1.782.33"
  })));
};
export default SvgMessageQuestion;